import { EllipsedText } from '@gorila-shared-ui/components';
import { memo } from 'react';
import { useRecoilValue } from 'recoil';
import { gptAlarmTypeNameState } from '../../../storage/gptStates';

type Props = Readonly<{
  code: number;
}>;

function AlarmsReportEventType({ code }: Props) {
  const notificationType = useRecoilValue(gptAlarmTypeNameState(code));

  return <EllipsedText maxLines={2}>{notificationType ?? '-'}</EllipsedText>;
}

export default memo(AlarmsReportEventType);
